import { getJSON } from '../../libs/data'
import { setSearchDataAction } from '../Artist/ArtistActions'
import { createKommuneLocationFilter } from '../../models/LocationFilter'
import { hasCountiesLoadedSelector, hasFylkerLoadedSelector } from './LocationsReducer'

export const FETCH_LOCATIONS_PENDING = 'FETCH_LOCATIONS_PENDING'
export const FETCH_LOCATIONS_FULFILLED = 'FETCH_LOCATIONS_FULFILLED'
export const FETCH_LOCATIONS_REJECTED = 'FETCH_LOCATIONS_REJECTED'

export const FETCH_FYLKER_PENDING = 'FETCH_FYLKER_PENDING'
export const FETCH_FYLKER_FULFILLED = 'FETCH_FYLKER_FULFILLED'
export const FETCH_FYLKER_REJECTED = 'FETCH_FYLKER_REJECTED'

export const FETCH_LOCATIONS_CHILDREN_PENDING = 'FETCH_LOCATIONS_CHILDREN_PENDING'
export const FETCH_LOCATIONS_CHILDREN_FULFILLED = 'FETCH_LOCATIONS_CHILDREN_FULFILLED'
export const FETCH_LOCATIONS_CHILDREN_REJECTED = 'FETCH_LOCATIONS_CHILDREN_REJECTED'

export const searchLocationsAction = (q, limit = 20) => () => {
  const query = encodeURIComponent((q || '').trim())
  if (!query) return Promise.resolve([])
  return getJSON(`/api/v1/location/searchKommune?q=${query}&limit=${limit}`).then(
    json => (Array.isArray(json) ? json : []),
    () => [],
  )
}

export const fetchKommuneByIdAction = id => dispatch => {
  if (!id) return Promise.resolve(null)
  return getJSON(`/api/v1/location/kommuneById?id=${encodeURIComponent(id)}`).then(
    kommune => {
      // Rehydrates the display label (and the kommune's fylke, used by "expand to region")
      // for a location deeplinked as a bare kommunenummer.
      const locationFilter = createKommuneLocationFilter(kommune)
      if (locationFilter && locationFilter.name) {
        dispatch(setSearchDataAction({ locationFilter }))
      }
      return kommune
    },
    () => null,
  )
}

/*
  The canonical fylke list comes from the api rather than a hardcoded copy, so the values the
  picker offers can never drift from the ones artist search accepts. Cached for 4h like the
  other reference data.
*/
export const fetchFylkerAction = (req = null) => dispatch => {
  dispatch({ type: FETCH_FYLKER_PENDING })
  return getJSON('/api/v1/location/fylker', { req, ttl: 60 * 60 * 4 }).then(
    json => {
      dispatch({
        type: FETCH_FYLKER_FULFILLED,
        payload: {
          data: Array.isArray(json) ? json : [],
          receivedAt: Date.now(),
        },
      })
    },
    () => {
      dispatch({ type: FETCH_FYLKER_REJECTED })
    },
  )
}

export const fetchFylkerIfNeededAction = (req = null) => (dispatch, getState) => {
  if (hasFylkerLoadedSelector(getState())) return Promise.resolve()
  return dispatch(fetchFylkerAction(req))
}

export const getCounties = (req = null) => dispatch => {
  dispatch({ type: FETCH_LOCATIONS_PENDING })
  return getJSON('/api/v1/location/getLocations', { req, ttl: 60 * 60 * 4 }).then(
    json => {
      dispatch({
        type: FETCH_LOCATIONS_FULFILLED,
        payload: {
          data: json,
          receivedAt: Date.now(),
        },
      })
    },
    error => {
      dispatch({ type: FETCH_LOCATIONS_REJECTED })
    },
  )
}

export const getCountiesIfNeededAction = () => (dispatch, getState) => {
  if (!hasCountiesLoadedSelector(getState())) {
    dispatch(getCounties())
  }
}

export const getChildrenLocations = parentId => dispatch => {
  dispatch({ type: FETCH_LOCATIONS_CHILDREN_PENDING })
  return getJSON(`/api/v1/location/getLocations?parent=${parentId}`, {
    req: {},
    ttl: 60 * 60 * 4,
  }).then(
    json => {
      dispatch({
        type: FETCH_LOCATIONS_CHILDREN_FULFILLED,
        payload: {
          data: json,
          parentId,
          receivedAt: Date.now(),
        },
      })
    },
    error => {
      dispatch({ type: FETCH_LOCATIONS_CHILDREN_REJECTED })
    },
  )
}

export const getLocationsIfNeeded = (req = null) => (dispatch, getState) => {
  const {
    locations: { counties, isFetching },
  } = getState()

  if ((counties && counties.length > 0) || isFetching) {
    return null
  }
  return dispatch(getCounties(req))
}
